import { ReactComponent as Home } from 'src/assets/home.svg'
import { ReactComponent as Author } from 'src/assets/author.svg';
import { ReactComponent as Goods } from 'src/assets/goods.svg';
import { ReactComponent as Profile } from 'src/assets/profile.svg';
import { ReactComponent as ProfileImg } from 'src/assets/profileImg.svg';
import { ReactComponent as Logout } from 'src/assets/logout.svg';
import profile from 'src/assets/img/Oauth/profile.jpg';
import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import LoginModal from "../modal/LoginModal";

interface DropdownMenu {
    handleClick: () => void;
    closeSidebar: () => void;
    isUser: string;
    token: string;
    setToken: (token: string) => void;
    nickName?: string;
    dropdownRef: React.RefObject<HTMLDivElement>;
    onLoginClick: () => void;
}
const DropdownMenu: React.FC<DropdownMenu> = ({ handleClick, closeSidebar, isUser, token, setToken, nickName, dropdownRef, onLoginClick }) => {

    const [showSidebar, setShowSidebar] = useState(false);
    const [docHeight, setDocHeight] = useState(0);
    const [nick, setNickName] = useState(nickName);

    const location = useLocation();
    const pathname = location.pathname;


    useEffect(() => {
        const fullHeight = Math.max(
            document.body.scrollHeight,
            document.documentElement.scrollHeight
        );
        setDocHeight(fullHeight - 100);
    }, []);

    const [showSignup, setShowSignup] = useState(false);
    const navigate = useNavigate();
    const closeModal = () => {
        setShowSignup(false);
    };


    return (
        <>
        <div ref={dropdownRef} className="absolute top-24 right-0 w-[300px] bg-white z-[999] shadow-2xl rounded-l-[40px] border-l border-gray-100 flex flex-col overflow-hidden transition-all duration-300 ease-in-out" style={{ height: `${docHeight}px` }}>
            <ul className="list-none py-[50px] px-[24px] gap-[32px] flex flex-col ">
                {/* 프로필 및 로그아웃 섹션 */}
                <div className="flex flex-col gap-6 ">
                    <li className="flex flex-col gap-2">
                        {nickName !== '로그인' && nickName ? (
                            <div className="flex items-baseline flex-wrap">
                                <span className="text-black font-bold text-[20px] tracking-tight">
                                    {nickName}{nickName.split(' ').length > 1 && nickName.split(' ')[1] === "작가님" ? '' : '님'},
                                </span>
                                <span className="text-[#8D8D8D] text-[15px] font-normal ml-1">
                                    안녕하세요!
                                </span>
                            </div>
                        ) : (
                            <span className="text-black font-bold text-[20px] tracking-tight">반가워요!</span>
                        )}
                    </li>

                    <div className="flex items-center gap-[12px]">
                        {nickName !== '로그인' && nickName &&
                            <Link to={`/mypage`} onClick={closeSidebar} className="flex-1">
                                <button className="w-full bg-main text-white py-[14px] rounded-full flex items-center justify-center active:scale-95 transition-all outline-none">
                                    <span className="font-bold text-sm tracking-tight text-white">
                                        {nickName.split(' ').length > 1 && nickName.split(' ')[1] === "작가님" ? '나의 책장' : '나의 책갈피'}
                                    </span>
                                </button>
                            </Link>
                        }

                        <button
                            className={`flex-1 ${nickName !== '로그인' ? 'bg-white text-[#495057] border-[#E9ECEF]' : 'bg-main text-white border-main'} border py-[14px] rounded-full flex items-center justify-center active:scale-95 transition-all outline-none font-bold`}
                            onClick={() => {
                                if (nickName === '로그인') {
                                    setShowSignup(true)
                                    onLoginClick();
                                } else {
                                    handleClick();
                                }
                            }}>
                            <span className="text-sm font-bold">
                                {nickName === "로그인" ? "로그인" : "로그아웃"}
                            </span>
                        </button>
                    </div>

                    <hr className="border-0 h-[1px] bg-main w-full mt-2" />
                </div>

                {/* 메뉴 리스트 섹션 */}
                <div className="flex flex-col">
                    {[
                        { path: "/author", label: "작가의 서재" },
                        { path: "/book", label: "작품 스토리" },
                        { path: "/postcard", label: "엽서북" },
                        { path: "/bookpair", label: "북페어 캘린더" },
                    ].map((item, idx) => (
                        <Link key={idx} to={item.path} onClick={closeSidebar}>
                            <li className={`py-4 px-4 rounded-full transition-all active:scale-[0.98] ${pathname === item.path ? "text-main font-bold" : "text-[#495057] hover:bg-gray-50 active:bg-gray-100"}`}>
                                <span className={`text-[18px] tracking-tight  ${pathname === item.path ? "text-main" : ""}`}>{item.label}</span>
                            </li>
                        </Link>
                    ))}
                </div>
            </ul>

        </div>
        {showSignup && <LoginModal setNickName={setNickName} token={token} setToken={setToken}
            onClose={() => {
                setShowSignup(false);
                if (localStorage.getItem("jwtToken")) {
                    navigate(0);
                }
            }}
            closeModal={() => {
                setShowSignup(false);
                if (localStorage.getItem("jwtToken")) {
                    navigate(0);
                }
            }} />}
        </>
    );
};

export default DropdownMenu;
